// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Dashboard Layout */
.incentive-dashboard {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #f9fafc;
  min-height: 100vh;
  color: #333333;
  letter-spacing: -0.01em;
  display: flex;
  flex-direction: column;
}

.dashboard-container {
  display: flex;
  margin-top: -20px;
  height: calc(100vh - 10px);
  overflow: hidden; /* Prevent overall scrolling */
}

.not-acheived{
  color: #888888;
  /* font-size: 14px;
  font-weight: 500; */
}

/* Fixed Sidebar Styles */
.pods-sidebar {
  /* width: 300px;
  min-width: 300px; */
  background-color: #ffffff;
  padding: 24px;
  border-right: 1px solid #eaedf3;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  height: 100%;
  overflow-y: auto;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
}

.sidebar-header {
  position: relative;
  margin-bottom: 24px;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: center;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
}

.sidebar-divider {
  height: 3px;
  width: 60px;
  background: linear-gradient(90deg, #7E57FF, #3B82F6);
  margin: 0 auto;
  border-radius: 3px;
}

/* Scrollable Main Content */
.main-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto; /* Make this container scrollable */
  height: 100%;
}

.content-header {
  margin-bottom: 24px;
}

.program-title {
  font-size: 24px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 8px;
}

.program-subtitle {
  font-size: 16px;
  color: #666666;
}

/* Pod Item Styles */
.pods-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d4d4d8 #f4f4f5;
}

.pods-list::-webkit-scrollbar {
  width: 6px;
}

.pods-list::-webkit-scrollbar-track {
  background: #f4f4f5;
  border-radius: 3px;
}

.pods-list::-webkit-scrollbar-thumb {
  background-color: #d4d4d8;
  border-radius: 3px;
}

.pod-item {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaedf3;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.pod-item.active {
  border-left: 4px solid #7E57FF;
  background-color: #f9f7ff;
}

.pod-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.pod-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.pod-name {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.pod-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pod-personnel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.personnel-item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666666;
}

.personnel-label {
  font-weight: 500;
}

.personnel-value {
  color: #333333;
}

.pod-target {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(90deg, rgba(126, 87, 255, 0.1), rgba(59, 130, 246, 0.1));
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
}

.target-label {
  font-weight: 500;
  color: #666666;
}

.target-value {
  font-weight: 600;
  color: #333333;
}

.pod-active-indicator {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #666666;
  gap: 16px;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(126, 87, 255, 0.2);
  border-top-color: #7E57FF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-pods-message {
  padding: 40px 20px;
  text-align: center;
  color: #888888;
  font-size: 15px;
  background-color: #f8f8f8;
  border-radius: 12px;
  border: 1px dashed #dddddd;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .dashboard-container {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }
  
  .pods-sidebar {
    width: 100%;
    min-width: 100%;
    position: relative;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #eaedf3;
    padding: 16px;
  }
  
  .pods-list {
    max-height: 400px;
  }
  
  .main-content {
    height: auto;
    overflow: visible;
  }
}

@media (max-width: 768px) {
  .pods-list {
    max-height: 300px;
  }
  
  .pod-item {
    padding: 12px;
  }
  
  .pod-name {
    font-size: 14px;
  }
  
  .personnel-item, .pod-target {
    font-size: 12px;
  }
}

/* Typography Enhancements */
h1, h2, h3, h4, h5, h6 {
  color: #111111;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

p, div {
  line-height: 1.6;
}

/* Updated Modern Pods Sidebar Styles */
.pods-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 16px;
  gap: 16px;
  max-height: calc(100vh - 185px);
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d4d4d8 #f4f4f5;
}

.pods-list::-webkit-scrollbar {
  width: 6px;
}

.pods-list::-webkit-scrollbar-track {
  background: #f4f4f5;
  border-radius: 10px;
}

.pods-list::-webkit-scrollbar-thumb {
  background-color: #d4d4d8;
  border-radius: 10px;
}

.pod-item:hover {
  background-color: #fafafa;
}

.pod-item.active {
  background-color: #f8f7ff !;
  border-color: #7E57FF !important;
}

.pod-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.pod-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 0 4px rgba(126, 87, 255, 0.1);
}

.pod-name {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pod-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pod-personnel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.personnel-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
}

.personnel-label {
  font-weight: 600;
  margin-right: 6px;
  color: #555555;
  min-width: 40px;
}

.personnel-value {
  color: #333333;
}

.pod-target {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(90deg, rgba(126, 87, 255, 0.08), rgba(59, 130, 246, 0.08));
  border-radius: 8px;
  margin-top: 4px;
  overflow: hidden;
}

.target-label {
  font-weight: 600;
  margin-right: 6px;
  color: #555555;
}

.target-value {
  font-weight: 700;
  color: #333333;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #888888;
  gap: 16px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(126, 87, 255, 0.2);
  border-top-color: #7E57FF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-pods-message {
  padding: 40px 20px;
  text-align: center;
  color: #888888;
  font-size: 15px;
  background-color: #f8f8f8;
  border-radius: 12px;
  border: 1px dashed #dddddd;
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid #eeeeee;
  margin-top: auto;
}

.sidebar-stats {
  display: flex;
  justify-content: space-between;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #888888;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

/* Top Navigation */
.top-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.nav-items {
  display: flex;
  gap: 24px;
}

.nav-item {
  font-size: 14px;
  font-weight: 500;
  color: #888888;
  cursor: pointer;
  padding-bottom: 5px;
  position: relative;
}

.nav-item.active {
  color: #333333;
  font-weight: 600;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #5E5CE6;
}

.nav-filters {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-tag {
  background-color: #f0f0f0;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.view-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.toggle-label {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease;
  padding: 4px 8px;
  border-radius: 12px;
}

.toggle-label.active {
  color: #3B82F6;
  font-weight: 500;
  background-color: rgba(59, 130, 246, 0.1);
}

.view-switch {
  background-color: #3B82F6;
}

.ant-switch-checked {
  background-color: #3B82F6 !important;
}

/* Section header that contains the toggle */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
}

.section-title {
  margin: 0;
  font-size: 20px !important;
    font-weight: 600;
    color: #104174;
    /* color: #333333; */
    margin-left: 30px;
  
}

/* Incentive Program Header */
.incentive-program {
  margin-bottom: 30px;
}

.program-day {
  font-size: 14px;
  color: #888888;
}

/* Metric Cards */
.metric-cards {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 16px;
  gap: 16px;
  /* margin-bottom: 30px; */
}

.metric-card {
  background-color: #5E5CE6;
  border-radius: 16px;
  padding: 20px;
  color: white;
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.metric-value {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 4px;
}

.metric-label {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.8;
}

.metric-chart {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  opacity: 0.5;
}

/* Tabs Container */
.tabs-container {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.tab-item {
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #888888;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #333333;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #5E5CE6;
}

/* Statistics Container */
.statistics-container {
  margin-bottom: 30px;
}

.stat-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  gap: 16px;
}

.stat-card {
  background-color: #f8f8f8;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: white;
  font-size: 24px;
}

.stat-icon.green {
  background-color: #4CD964;
}

.stat-icon.blue {
  background-color: #5AC8FA;
}

.stat-icon.purple {
  background-color: #5E5CE6;
}

.stat-icon.orange {
  background-color: #FF9500;
}

.stat-time {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #888888;
}

/* Graphs Container */
.graphs-container {
  margin-bottom: 30px;
}

.graph-tabs {
  display: flex;
  margin-bottom: 16px;
}

.graph-tab {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #888888;
  cursor: pointer;
  border-radius: 20px;
  margin-right: 8px;
}

.graph-tab.active {
  background-color: #5E5CE6;
  color: white;
}

.graph-content {
  background-color: #f8f8f8;
  border-radius: 16px;
  padding: 20px;
  height: 300px;
}

.graph-chart {
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-top: 40px;
  position: relative;
}

.chart-column {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.column-bar {
  width: 16px;
  background-color: #e0e0e0;
  border-radius: 8px;
  transition: height 0.5s ease;
}

.column-bar.highlight {
  background-color: #5E5CE6;
}

.column-label {
  margin-top: 8px;
  font-size: 12px;
  color: #888888;
}

.column-highlight {
  position: absolute;
  top: -30px;
  background-color: #5E5CE6;
  color: white;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

/* Calendar Section Styles */
.calendar-section {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  /* margin-top: 20px; */
  overflow: hidden;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.calendar-title-section {
  display: flex;
  flex-direction: column;
}

.current-month {
  font-size: 20px;
  font-weight: 700;
  color: #111111;
  margin: 0;
}

.day-indicator {
  font-size: 14px;
  color: #888888;
  margin-top: 4px;
}

.calendar-controls {
  display: flex;
  gap: 8px;
}

.month-nav-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #333333;
  font-size: 14px;
  transition: all 0.2s ease;
}

.month-nav-button:hover {
  background-color: #f8f8f8;
}

.add-note-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5E5CE6;
  font-size: 18px;
  font-weight: 600;
  margin-left: 8px;
  transition: all 0.2s ease;
}

.add-note-button:hover {
  background-color: #5E5CE6;
  color: #ffffff;
}

.calendar-grid {
  padding: 16px 24px 24px;
}

.weekday-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 12px;
}

.weekday-label {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #888888;
  padding: 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 8px;
  gap: 8px;
}

.calendar-day {
  /* aspect-ratio: ; */
  background-color: #f8f8f8;
  border-radius: 16px;
  padding: 10px;
  position: relative;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
}

.calendar-day:hover {
  background-color: #f0f0f0;
}

.calendar-day.empty {
  background-color: transparent;
}

.calendar-day.weekend {
  background-color: #f5f5f5;
}

.calendar-day.today {
  background-color: #f0f0ff;
  border: 1px solid rgba(94, 92, 230, 0.3);
}

.day-number {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.today-number {
  color: #5E5CE6;
  font-weight: 700;
}

.today-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #5E5CE6;
}

.day-data {
  margin-top: auto;
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(94, 92, 230, 0.1);
  border-left: 3px solid #5E5CE6;
}

.data-amount {
  font-size: 14px;
  font-weight: 700;
  color: #111111;
}

.data-count {
  font-size: 12px;
  /* color: #666666; */
  margin-top: 2px;
}

.calendar-summary {
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #f8f8f8;
  border-top: 1px solid #eeeeee;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary-label {
  font-size: 12px;
  color: #888888;
  margin-bottom: 4px;
}

.summary-value {
  font-size: 16px;
  font-weight: 700;
  color: #333333;
}

.summary-value.highlight {
  color: #5E5CE6;
}

/* Helper function to convert hex to rgb */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(94, 92, 230, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(94, 92, 230, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(94, 92, 230, 0);
  }
}

/* Notes Section */
.notes-section {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  gap: 16px;
}

.note-card {
  border-radius: 16px;
  padding: 20px;
  position: relative;
}

.note-card h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.note-card p {
  font-size: 14px;
  color: #555555;
  margin: 0;
}

.note-card.green {
  background-color: #E8F8F0;
  border-left: 4px solid #4CD964;
}

.note-card.blue {
  background-color: #E8F4FF;
  border-left: 4px solid #5AC8FA;
}

.note-card.yellow {
  background-color: #FFF8E8;
  border-left: 4px solid #FFCC00;
}

/* Insight Cards Styles - Updated to match the image */
.insights-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  gap: 16px;
  margin-bottom: 24px;
}

.insight-card {
  border-radius: 16px;
  padding: 20px;
  color: white;
  display: flex;
  flex-direction: row;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  /* margin-bottom: 8px; */
}

.card-value {
  font-size: 20px;
  font-weight: 700;
  /* margin-bottom: 16px; */
}

.progress-bar {
  height: 6px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  margin-bottom: 8px;
}

.progress-track {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  transition: width 0.5s ease;
}

.card-percentage {
  font-size: 16px;
  font-weight: 600;
  text-align: right;
}

/* Pod Comparison Section Styles */
.pod-comparison-section {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.pod-comparison-chart {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.pod-bar-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pod-bar-label {
  width: 180px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pod-bar-wrapper {
  flex: 1 1;
  height: 12px;
  background-color: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.pod-bar {
  height: 100%;
  border-radius: 6px;
}

.pod-bar-value {
  width: 100px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  text-align: right;
}

.pod-bar-count {
  width: 80px;
  font-size: 13px;
  color: #666666;
  text-align: right;
}

.pod-bar-container.others .pod-bar-label {
  color: #666666;
}

.pod-comparison-summary {
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #eeeeee;
}

.no-data-message {
  padding: 40px;
  text-align: center;
  color: #888888;
  font-size: 15px;
  background-color: #f8f8f8;
  border-radius: 12px;
  border: 1px dashed #dddddd;
  margin: 20px 0;
}

/* Keep the rest of your existing CSS */
.Pod-name{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.Pod-name-label{
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}

.Pod-name-value{
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

/* Loader Styles */
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
  gap: 16px;
}

.loader-text {
  color: #666666;
  font-size: 14px;
  margin-top: 12px;
}

/* Shimmer Effect Styles */
.shimmer {
  position: relative;
  overflow: hidden;
  background-color: #f6f7f8;
}

.shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* Shimmer for Insight Cards */
.insight-card.shimmer {
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.shimmer-value {
  width: 80%;
  height: 28px;
  background-color: #eaeaea;
  border-radius: 4px;
  margin-bottom: 12px;
}

.shimmer-label {
  width: 60%;
  height: 14px;
  background-color: #eaeaea;
  border-radius: 4px;
}

/* Shimmer for Pod Comparison */
.pod-bar-container.shimmer {
  height: 40px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.shimmer-label {
  width: 150px;
  height: 16px;
  background-color: #eaeaea;
  border-radius: 4px;
}

.shimmer-bar {
  flex: 1 1;
  height: 12px;
  background-color: #eaeaea;
  border-radius: 6px;
}

.shimmer-value {
  width: 60px;
  height: 16px;
  background-color: #eaeaea;
  border-radius: 4px;
}

/* Shimmer for Calendar */
.calendar-grid.shimmer {
  height: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shimmer-weekdays {
  height: 40px;
  background-color: #eaeaea;
  border-radius: 8px;
}

.shimmer-days {
  flex: 1 1;
  background-color: #eaeaea;
  border-radius: 8px;
}

/* Shimmer for Pod Items */
.pod-item.shimmer {
  height: 70px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shimmer-pod-name {
  width: 80%;
  height: 18px;
  background-color: #eaeaea;
  border-radius: 4px;
}

.shimmer-pod-details {
  width: 60%;
  height: 14px;
  background-color: #eaeaea;
  border-radius: 4px;
}



.insight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.card-icon svg {
  font-size: 24px;
  color: white;
}

.card-content {
  flex: 1 1;
}

.card-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 8px;
}

.card-value {
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
}

.progress-bar {
  height: 6px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background-color: lightgreen;
  border-radius: 3px;
  transition: width 0.5s ease;
}

.card-percentage {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
}

/* Secondary Insight Cards */
.insight-cards.secondary {
  margin-top: 24px;
}

.insight-card.secondary {
  background-color: white;
  color: #333333;
  border: 1px solid #eaedf3;
}

.card-icon.secondary {
  background-color: #f0f7ff;
}

.card-icon.secondary svg {
  color: #3B82F6;
}

.insight-card.secondary .card-title {
  color: #666666;
}

.insight-card.secondary .card-value {
  color: #333333;
}

/* Card-specific icon colors */
.insight-card:nth-child(1) .card-icon svg {
  color: #7E57FF;
}

.insight-card:nth-child(2) .card-icon svg {
  color: #3B82F6;
}

.insight-card:nth-child(3) .card-icon svg {
  color: #F59E0B;
}

.insight-card:nth-child(4) .card-icon svg {
  color: #10B981;
}

/* Card-specific background colors for secondary cards */
.insight-cards.secondary .insight-card:nth-child(1) .card-icon {
  background-color: rgba(126, 87, 255, 0.1);
}

.insight-cards.secondary .insight-card:nth-child(2) .card-icon {
  background-color: rgba(59, 130, 246, 0.1);
}

.insight-cards.secondary .insight-card:nth-child(3) .card-icon {
  background-color: rgba(245, 158, 11, 0.1);
}

.insight-cards.secondary .insight-card:nth-child(4) .card-icon {
  background-color: rgba(16, 185, 129, 0.1);
}

/* Shimmer effect for loading cards */
.insight-card.shimmer {
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.shimmer-value {
  width: 80%;
  height: 28px;
  background-color: #eaeaea;
  border-radius: 4px;
  margin-bottom: 12px;
}

.shimmer-label {
  width: 60%;
  height: 14px;
  background-color: #eaeaea;
  border-radius: 4px;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .insight-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card-icon {
    width: 40px;
    height: 40px;
  }
  
  .card-icon svg {
    font-size: 20px;
  }
  
  .card-value {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .insight-cards {
    grid-template-columns: 1fr;
  }
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .view-toggle {
    padding: 2px 8px;
  }
  
  .toggle-label {
    font-size: 12px;
    padding: 2px 4px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .section-title {
    margin-bottom: 8px;
    /* font-size: 25px; */
    font-weight: 600;
    color: #333333;
    margin-left: 10px;
  }
}

.modality-breakdown {
  min-width: 240px;
  padding: 8px 0;
}

.breakdown-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding: 4px 12px;
  border-bottom: 1px solid #eaedf3;
  font-weight: 600;
  color: #666666;
  font-size: 12px;
}

.breakdown-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding: 8px 12px;
  font-size: 13px;
  transition: background-color 0.2s;
}

.breakdown-row:hover {
  background-color: #f8f9fa;
}

.modality-name {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.modality-name::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.modality-name.xray::before {
  background-color: #0369a1;
}

.modality-name.mri::before {
  background-color: #166534;
}

.modality-name.ct::before {
  background-color: #92400e;
}

.modality-name.nm::before {
  background-color: #7e22ce;
}

.modality-name.other::before {
  background-color: #475569;
}

.modality-count {
  text-align: center;
  color: #666666;
}

.modality-amount {
  text-align: right;
  font-weight: 500;
  color: #333333;
}

.breakdown-total {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding: 8px 12px;
  border-top: 1px solid #eaedf3;
  margin-top: 4px;
  font-weight: 600;
  background-color: #f8f9fa;
}

.breakdown-total > span:first-child {
  color: #666666;
}

.breakdown-total > span:nth-child(2) {
  text-align: center;
}

.breakdown-total > span:last-child {
  text-align: right;
}

/* Make the day data container clickable */
.day-data-container {
  cursor: pointer;
}

/* Optional: Add a subtle hover effect */
.day-data-container:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/components/Contribution/Incentive/Incentive.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,uFAAuF;EACvF,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,cAAc;EACd;qBACmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;qBACmB;EACnB,yBAAyB;EACzB,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,cAAc;EACd,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB,EAAE,mCAAmC;EACrD,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oFAAoF;EACpF,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAS;EAAT,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sFAAsF;EACtF,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EAIE,SAAS;EACT,0BAA0B;IACxB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;;AAErB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,4BAA4B;EAC5B;;;;;;GAMC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;;;AAIA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,YAAY;AACd","sourcesContent":["/* Main Dashboard Layout */\n.incentive-dashboard {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background-color: #f9fafc;\n  min-height: 100vh;\n  color: #333333;\n  letter-spacing: -0.01em;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-container {\n  display: flex;\n  margin-top: -20px;\n  height: calc(100vh - 10px);\n  overflow: hidden; /* Prevent overall scrolling */\n}\n\n.not-acheived{\n  color: #888888;\n  /* font-size: 14px;\n  font-weight: 500; */\n}\n\n/* Fixed Sidebar Styles */\n.pods-sidebar {\n  /* width: 300px;\n  min-width: 300px; */\n  background-color: #ffffff;\n  padding: 24px;\n  border-right: 1px solid #eaedf3;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  height: 100%;\n  overflow-y: auto;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n\n.sidebar-header {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.sidebar-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  letter-spacing: 0.05em;\n  margin-bottom: 12px;\n}\n\n.sidebar-divider {\n  height: 3px;\n  width: 60px;\n  background: linear-gradient(90deg, #7E57FF, #3B82F6);\n  margin: 0 auto;\n  border-radius: 3px;\n}\n\n/* Scrollable Main Content */\n.main-content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto; /* Make this container scrollable */\n  height: 100%;\n}\n\n.content-header {\n  margin-bottom: 24px;\n}\n\n.program-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333333;\n  margin-bottom: 8px;\n}\n\n.program-subtitle {\n  font-size: 16px;\n  color: #666666;\n}\n\n/* Pod Item Styles */\n.pods-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: calc(100vh - 150px);\n  overflow-y: auto;\n  padding: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #d4d4d8 #f4f4f5;\n}\n\n.pods-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.pods-list::-webkit-scrollbar-track {\n  background: #f4f4f5;\n  border-radius: 3px;\n}\n\n.pods-list::-webkit-scrollbar-thumb {\n  background-color: #d4d4d8;\n  border-radius: 3px;\n}\n\n.pod-item {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eaedf3;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.pod-item.active {\n  border-left: 4px solid #7E57FF;\n  background-color: #f9f7ff;\n}\n\n.pod-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.pod-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 10px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n}\n\n.pod-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n}\n\n.pod-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pod-personnel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.personnel-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #666666;\n}\n\n.personnel-label {\n  font-weight: 500;\n}\n\n.personnel-value {\n  color: #333333;\n}\n\n.pod-target {\n  display: flex;\n  justify-content: space-between;\n  background: linear-gradient(90deg, rgba(126, 87, 255, 0.1), rgba(59, 130, 246, 0.1));\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.target-label {\n  font-weight: 500;\n  color: #666666;\n}\n\n.target-value {\n  font-weight: 600;\n  color: #333333;\n}\n\n.pod-active-indicator {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 4px;\n  height: 100%;\n}\n\n.loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n  color: #666666;\n  gap: 16px;\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid rgba(126, 87, 255, 0.2);\n  border-top-color: #7E57FF;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.no-pods-message {\n  padding: 40px 20px;\n  text-align: center;\n  color: #888888;\n  font-size: 15px;\n  background-color: #f8f8f8;\n  border-radius: 12px;\n  border: 1px dashed #dddddd;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .dashboard-container {\n    flex-direction: column;\n    height: auto;\n    overflow: visible;\n  }\n  \n  .pods-sidebar {\n    width: 100%;\n    min-width: 100%;\n    position: relative;\n    height: auto;\n    border-right: none;\n    border-bottom: 1px solid #eaedf3;\n    padding: 16px;\n  }\n  \n  .pods-list {\n    max-height: 400px;\n  }\n  \n  .main-content {\n    height: auto;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 768px) {\n  .pods-list {\n    max-height: 300px;\n  }\n  \n  .pod-item {\n    padding: 12px;\n  }\n  \n  .pod-name {\n    font-size: 14px;\n  }\n  \n  .personnel-item, .pod-target {\n    font-size: 12px;\n  }\n}\n\n/* Typography Enhancements */\nh1, h2, h3, h4, h5, h6 {\n  color: #111111;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0;\n}\n\np, div {\n  line-height: 1.6;\n}\n\n/* Updated Modern Pods Sidebar Styles */\n.pods-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  max-height: calc(100vh - 185px);\n  overflow-y: auto;\n  padding: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #d4d4d8 #f4f4f5;\n}\n\n.pods-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.pods-list::-webkit-scrollbar-track {\n  background: #f4f4f5;\n  border-radius: 10px;\n}\n\n.pods-list::-webkit-scrollbar-thumb {\n  background-color: #d4d4d8;\n  border-radius: 10px;\n}\n\n.pod-item:hover {\n  background-color: #fafafa;\n}\n\n.pod-item.active {\n  background-color: #f8f7ff !;\n  border-color: #7E57FF !important;\n}\n\n.pod-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.pod-color {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-right: 12px;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 0 0 4px rgba(126, 87, 255, 0.1);\n}\n\n.pod-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pod-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pod-personnel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.personnel-item {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #666666;\n}\n\n.personnel-label {\n  font-weight: 600;\n  margin-right: 6px;\n  color: #555555;\n  min-width: 40px;\n}\n\n.personnel-value {\n  color: #333333;\n}\n\n.pod-target {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: linear-gradient(90deg, rgba(126, 87, 255, 0.08), rgba(59, 130, 246, 0.08));\n  border-radius: 8px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n\n.target-label {\n  font-weight: 600;\n  margin-right: 6px;\n  color: #555555;\n}\n\n.target-value {\n  font-weight: 700;\n  color: #333333;\n}\n\n.loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n  color: #888888;\n  gap: 16px;\n}\n\n.spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid rgba(126, 87, 255, 0.2);\n  border-top-color: #7E57FF;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.no-pods-message {\n  padding: 40px 20px;\n  text-align: center;\n  color: #888888;\n  font-size: 15px;\n  background-color: #f8f8f8;\n  border-radius: 12px;\n  border: 1px dashed #dddddd;\n}\n\n.sidebar-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #eeeeee;\n  margin-top: auto;\n}\n\n.sidebar-stats {\n  display: flex;\n  justify-content: space-between;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #888888;\n  margin-bottom: 4px;\n}\n\n.stat-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n}\n\n/* Top Navigation */\n.top-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.nav-items {\n  display: flex;\n  gap: 24px;\n}\n\n.nav-item {\n  font-size: 14px;\n  font-weight: 500;\n  color: #888888;\n  cursor: pointer;\n  padding-bottom: 5px;\n  position: relative;\n}\n\n.nav-item.active {\n  color: #333333;\n  font-weight: 600;\n}\n\n.nav-item.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #5E5CE6;\n}\n\n.nav-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.filter-tag {\n  background-color: #f0f0f0;\n  border-radius: 16px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #333333;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.view-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f5f7fa;\n  padding: 4px 12px;\n  border-radius: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.toggle-label {\n  font-size: 14px;\n  color: #666666;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: all 0.2s ease;\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n.toggle-label.active {\n  color: #3B82F6;\n  font-weight: 500;\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.view-switch {\n  background-color: #3B82F6;\n}\n\n.ant-switch-checked {\n  background-color: #3B82F6 !important;\n}\n\n/* Section header that contains the toggle */\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333333;\n  margin: 0;\n  font-size: 20px !important;\n    font-weight: 600;\n    color: #104174;\n    /* color: #333333; */\n    margin-left: 30px;\n  \n}\n\n/* Incentive Program Header */\n.incentive-program {\n  margin-bottom: 30px;\n}\n\n.program-day {\n  font-size: 14px;\n  color: #888888;\n}\n\n/* Metric Cards */\n.metric-cards {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 16px;\n  /* margin-bottom: 30px; */\n}\n\n.metric-card {\n  background-color: #5E5CE6;\n  border-radius: 16px;\n  padding: 20px;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.metric-value {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.metric-label {\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0.8;\n}\n\n.metric-chart {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  opacity: 0.5;\n}\n\n/* Tabs Container */\n.tabs-container {\n  display: flex;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.tab-item {\n  padding: 12px 20px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #888888;\n  cursor: pointer;\n  position: relative;\n}\n\n.tab-item.active {\n  color: #333333;\n  font-weight: 600;\n}\n\n.tab-item.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #5E5CE6;\n}\n\n/* Statistics Container */\n.statistics-container {\n  margin-bottom: 30px;\n}\n\n.stat-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.stat-card {\n  background-color: #f8f8f8;\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  color: white;\n  font-size: 24px;\n}\n\n.stat-icon.green {\n  background-color: #4CD964;\n}\n\n.stat-icon.blue {\n  background-color: #5AC8FA;\n}\n\n.stat-icon.purple {\n  background-color: #5E5CE6;\n}\n\n.stat-icon.orange {\n  background-color: #FF9500;\n}\n\n.stat-time {\n  font-size: 20px;\n  font-weight: 700;\n  color: #333333;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #888888;\n}\n\n/* Graphs Container */\n.graphs-container {\n  margin-bottom: 30px;\n}\n\n.graph-tabs {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.graph-tab {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #888888;\n  cursor: pointer;\n  border-radius: 20px;\n  margin-right: 8px;\n}\n\n.graph-tab.active {\n  background-color: #5E5CE6;\n  color: white;\n}\n\n.graph-content {\n  background-color: #f8f8f8;\n  border-radius: 16px;\n  padding: 20px;\n  height: 300px;\n}\n\n.graph-chart {\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  padding-top: 40px;\n  position: relative;\n}\n\n.chart-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.column-bar {\n  width: 16px;\n  background-color: #e0e0e0;\n  border-radius: 8px;\n  transition: height 0.5s ease;\n}\n\n.column-bar.highlight {\n  background-color: #5E5CE6;\n}\n\n.column-label {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #888888;\n}\n\n.column-highlight {\n  position: absolute;\n  top: -30px;\n  background-color: #5E5CE6;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Calendar Section Styles */\n.calendar-section {\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  /* margin-top: 20px; */\n  overflow: hidden;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 24px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.calendar-title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.current-month {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111111;\n  margin: 0;\n}\n\n.day-indicator {\n  font-size: 14px;\n  color: #888888;\n  margin-top: 4px;\n}\n\n.calendar-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.month-nav-button {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 1px solid #eeeeee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #333333;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.month-nav-button:hover {\n  background-color: #f8f8f8;\n}\n\n.add-note-button {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 1px solid #eeeeee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #5E5CE6;\n  font-size: 18px;\n  font-weight: 600;\n  margin-left: 8px;\n  transition: all 0.2s ease;\n}\n\n.add-note-button:hover {\n  background-color: #5E5CE6;\n  color: #ffffff;\n}\n\n.calendar-grid {\n  padding: 16px 24px 24px;\n}\n\n.weekday-header {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 12px;\n}\n\n.weekday-label {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #888888;\n  padding: 8px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.calendar-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n}\n\n.calendar-day {\n  /* aspect-ratio: ; */\n  background-color: #f8f8f8;\n  border-radius: 16px;\n  padding: 10px;\n  position: relative;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.calendar-day:hover {\n  background-color: #f0f0f0;\n}\n\n.calendar-day.empty {\n  background-color: transparent;\n}\n\n.calendar-day.weekend {\n  background-color: #f5f5f5;\n}\n\n.calendar-day.today {\n  background-color: #f0f0ff;\n  border: 1px solid rgba(94, 92, 230, 0.3);\n}\n\n.day-number {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 8px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.today-number {\n  color: #5E5CE6;\n  font-weight: 700;\n}\n\n.today-indicator {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #5E5CE6;\n}\n\n.day-data {\n  margin-top: auto;\n  padding: 8px;\n  border-radius: 8px;\n  background-color: rgba(94, 92, 230, 0.1);\n  border-left: 3px solid #5E5CE6;\n}\n\n.data-amount {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111111;\n}\n\n.data-count {\n  font-size: 12px;\n  /* color: #666666; */\n  margin-top: 2px;\n}\n\n.calendar-summary {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background-color: #f8f8f8;\n  border-top: 1px solid #eeeeee;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.summary-label {\n  font-size: 12px;\n  color: #888888;\n  margin-bottom: 4px;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333333;\n}\n\n.summary-value.highlight {\n  color: #5E5CE6;\n}\n\n/* Helper function to convert hex to rgb */\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(94, 92, 230, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(94, 92, 230, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(94, 92, 230, 0);\n  }\n}\n\n/* Notes Section */\n.notes-section {\n  padding: 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.note-card {\n  border-radius: 16px;\n  padding: 20px;\n  position: relative;\n}\n\n.note-card h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.note-card p {\n  font-size: 14px;\n  color: #555555;\n  margin: 0;\n}\n\n.note-card.green {\n  background-color: #E8F8F0;\n  border-left: 4px solid #4CD964;\n}\n\n.note-card.blue {\n  background-color: #E8F4FF;\n  border-left: 4px solid #5AC8FA;\n}\n\n.note-card.yellow {\n  background-color: #FFF8E8;\n  border-left: 4px solid #FFCC00;\n}\n\n/* Insight Cards Styles - Updated to match the image */\n.insights-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.insight-card {\n  border-radius: 16px;\n  padding: 20px;\n  color: white;\n  display: flex;\n  flex-direction: row;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.card-title {\n  font-size: 15px;\n  font-weight: 600;\n  /* margin-bottom: 8px; */\n}\n\n.card-value {\n  font-size: 20px;\n  font-weight: 700;\n  /* margin-bottom: 16px; */\n}\n\n.progress-bar {\n  height: 6px;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.progress-track {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.progress-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 3px;\n  transition: width 0.5s ease;\n}\n\n.card-percentage {\n  font-size: 16px;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Pod Comparison Section Styles */\n.pod-comparison-section {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n.pod-comparison-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.pod-bar-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pod-bar-label {\n  width: 180px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pod-bar-wrapper {\n  flex: 1;\n  height: 12px;\n  background-color: #f0f0f0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.pod-bar {\n  height: 100%;\n  border-radius: 6px;\n}\n\n.pod-bar-value {\n  width: 100px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333333;\n  text-align: right;\n}\n\n.pod-bar-count {\n  width: 80px;\n  font-size: 13px;\n  color: #666666;\n  text-align: right;\n}\n\n.pod-bar-container.others .pod-bar-label {\n  color: #666666;\n}\n\n.pod-comparison-summary {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 16px;\n  border-top: 1px solid #eeeeee;\n}\n\n.no-data-message {\n  padding: 40px;\n  text-align: center;\n  color: #888888;\n  font-size: 15px;\n  background-color: #f8f8f8;\n  border-radius: 12px;\n  border: 1px dashed #dddddd;\n  margin: 20px 0;\n}\n\n/* Keep the rest of your existing CSS */\n.Pod-name{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.Pod-name-label{\n  font-size: 14px;\n  font-weight: 500;\n  color: #333333;\n}\n\n.Pod-name-value{\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n}\n\n/* Loader Styles */\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  gap: 16px;\n}\n\n.loader-text {\n  color: #666666;\n  font-size: 14px;\n  margin-top: 12px;\n}\n\n/* Shimmer Effect Styles */\n.shimmer {\n  position: relative;\n  overflow: hidden;\n  background-color: #f6f7f8;\n}\n\n.shimmer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transform: translateX(-100%);\n  background-image: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0,\n    rgba(255, 255, 255, 0.2) 20%,\n    rgba(255, 255, 255, 0.5) 60%,\n    rgba(255, 255, 255, 0)\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/* Shimmer for Insight Cards */\n.insight-card.shimmer {\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.shimmer-value {\n  width: 80%;\n  height: 28px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.shimmer-label {\n  width: 60%;\n  height: 14px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n/* Shimmer for Pod Comparison */\n.pod-bar-container.shimmer {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.shimmer-label {\n  width: 150px;\n  height: 16px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n.shimmer-bar {\n  flex: 1;\n  height: 12px;\n  background-color: #eaeaea;\n  border-radius: 6px;\n}\n\n.shimmer-value {\n  width: 60px;\n  height: 16px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n/* Shimmer for Calendar */\n.calendar-grid.shimmer {\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.shimmer-weekdays {\n  height: 40px;\n  background-color: #eaeaea;\n  border-radius: 8px;\n}\n\n.shimmer-days {\n  flex: 1;\n  background-color: #eaeaea;\n  border-radius: 8px;\n}\n\n/* Shimmer for Pod Items */\n.pod-item.shimmer {\n  height: 70px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.shimmer-pod-name {\n  width: 80%;\n  height: 18px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n.shimmer-pod-details {\n  width: 60%;\n  height: 14px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n\n\n.insight-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.card-icon svg {\n  font-size: 24px;\n  color: white;\n}\n\n.card-content {\n  flex: 1;\n}\n\n.card-title {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 8px;\n}\n\n.card-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 12px;\n}\n\n.progress-bar {\n  height: 6px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: lightgreen;\n  border-radius: 3px;\n  transition: width 0.5s ease;\n}\n\n.card-percentage {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.8);\n  text-align: right;\n}\n\n/* Secondary Insight Cards */\n.insight-cards.secondary {\n  margin-top: 24px;\n}\n\n.insight-card.secondary {\n  background-color: white;\n  color: #333333;\n  border: 1px solid #eaedf3;\n}\n\n.card-icon.secondary {\n  background-color: #f0f7ff;\n}\n\n.card-icon.secondary svg {\n  color: #3B82F6;\n}\n\n.insight-card.secondary .card-title {\n  color: #666666;\n}\n\n.insight-card.secondary .card-value {\n  color: #333333;\n}\n\n/* Card-specific icon colors */\n.insight-card:nth-child(1) .card-icon svg {\n  color: #7E57FF;\n}\n\n.insight-card:nth-child(2) .card-icon svg {\n  color: #3B82F6;\n}\n\n.insight-card:nth-child(3) .card-icon svg {\n  color: #F59E0B;\n}\n\n.insight-card:nth-child(4) .card-icon svg {\n  color: #10B981;\n}\n\n/* Card-specific background colors for secondary cards */\n.insight-cards.secondary .insight-card:nth-child(1) .card-icon {\n  background-color: rgba(126, 87, 255, 0.1);\n}\n\n.insight-cards.secondary .insight-card:nth-child(2) .card-icon {\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.insight-cards.secondary .insight-card:nth-child(3) .card-icon {\n  background-color: rgba(245, 158, 11, 0.1);\n}\n\n.insight-cards.secondary .insight-card:nth-child(4) .card-icon {\n  background-color: rgba(16, 185, 129, 0.1);\n}\n\n/* Shimmer effect for loading cards */\n.insight-card.shimmer {\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.shimmer-value {\n  width: 80%;\n  height: 28px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.shimmer-label {\n  width: 60%;\n  height: 14px;\n  background-color: #eaeaea;\n  border-radius: 4px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .insight-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .card-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .card-icon svg {\n    font-size: 20px;\n  }\n  \n  .card-value {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .insight-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .view-toggle {\n    padding: 2px 8px;\n  }\n  \n  .toggle-label {\n    font-size: 12px;\n    padding: 2px 4px;\n  }\n  \n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .section-title {\n    margin-bottom: 8px;\n    /* font-size: 25px; */\n    font-weight: 600;\n    color: #333333;\n    margin-left: 10px;\n  }\n}\n\n.modality-breakdown {\n  min-width: 240px;\n  padding: 8px 0;\n}\n\n.breakdown-header {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  padding: 4px 12px;\n  border-bottom: 1px solid #eaedf3;\n  font-weight: 600;\n  color: #666666;\n  font-size: 12px;\n}\n\n.breakdown-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  padding: 8px 12px;\n  font-size: 13px;\n  transition: background-color 0.2s;\n}\n\n.breakdown-row:hover {\n  background-color: #f8f9fa;\n}\n\n.modality-name {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.modality-name::before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.modality-name.xray::before {\n  background-color: #0369a1;\n}\n\n.modality-name.mri::before {\n  background-color: #166534;\n}\n\n.modality-name.ct::before {\n  background-color: #92400e;\n}\n\n.modality-name.nm::before {\n  background-color: #7e22ce;\n}\n\n.modality-name.other::before {\n  background-color: #475569;\n}\n\n.modality-count {\n  text-align: center;\n  color: #666666;\n}\n\n.modality-amount {\n  text-align: right;\n  font-weight: 500;\n  color: #333333;\n}\n\n.breakdown-total {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  padding: 8px 12px;\n  border-top: 1px solid #eaedf3;\n  margin-top: 4px;\n  font-weight: 600;\n  background-color: #f8f9fa;\n}\n\n.breakdown-total > span:first-child {\n  color: #666666;\n}\n\n.breakdown-total > span:nth-child(2) {\n  text-align: center;\n}\n\n.breakdown-total > span:last-child {\n  text-align: right;\n}\n\n/* Make the day data container clickable */\n.day-data-container {\n  cursor: pointer;\n}\n\n/* Optional: Add a subtle hover effect */\n.day-data-container:hover {\n  opacity: 0.9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
